import axios from 'axios';
import { setLocationCache } from './locationCacheManager';

const getExperienceFromApi = ({
  getExperienceForPositionApi,
  position,
  locationZipCodes,
  experienceTypes,
  cacheDuration,
  hmac,
  time
}) => {
  const latitude = position.latitude,
        longitude = position.longitude;
  const requestData = {
    latitude,
    longitude,
    locationZipCodes,
    experienceTypes
  };
  return axios.post(getExperienceForPositionApi, requestData, {
    headers: {
      'x-api-nonce': 'locationExperience',
      'x-api-timestamp': time,
      'x-api-hmac': hmac
    }
  }).then(response => {
    if (response && response.status === 200) {
      const result = response.data;

      if (result.LocationZipCodes) {
        setLocationCache({
          locationZipCodes: result.LocationZipCodes
        }, cacheDuration);
      }

      return result.IsSuccess ? result.ExperienceTypes : null;
    }

    return null;
  });
};

export default getExperienceFromApi;